import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`purchase_order_date_from`／`purchase_order_date_to`）。
 *
 * 前端 camel key：`purchaseOrderDateFrom`／`purchaseOrderDateTo`
 */
export function readPurchaseOrderDateRangeFilter(filters = {}) {
  const from = filters.purchaseOrderDateFrom;
  const to = filters.purchaseOrderDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyPurchaseOrderDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.purchaseOrderDateFrom;
    delete next.purchaseOrderDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.purchaseOrderDateFrom = from || undefined;
  next.purchaseOrderDateTo = to || undefined;

  return next;
}

export function resolvePurchaseOrderDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.purchaseOrderDateFrom,
    to: ctx.filters?.purchaseOrderDateTo,
  });

  return display ? [display] : [];
}

